module.exports = __webpack_public_path__ + "static/plano-loft-117c263debe6b5a175b01e04727f6cbf.jpg";